import { ANALYTICS_CONSTS as AC } from '../consts'
import services from '@/services/ascentiaServiceIndex'

const state = {
  analyticResultTypes: [],
  quartileRawResults: [],
  quartileSplitResults: {},
  quartileSplitResultsMissingTails: [],
  quartileResults: [],
  selection: {},
  sortItem: {
    sortAsc: true,
    sortField: 'tail',
    sortFieldName: 'Alphabetical',
  },
}

const getters = {}

const mutations = {
  [AC.UPDATE_ANALYTIC_RESULT_TYPES]: (state, data) =>
    (state.analyticResultTypes = data),
  [AC.UPDATE_QUARTILE_RAW_RESULTS]: (state, data) =>
    (state.quartileRawResults = data),
  [AC.UPDATE_QUARTILE_RESULTS]: (state, data) => (state.quartileResults = data),
  [AC.UPDATE_QUARTILE_SPLIT_RESULTS]: (state, data) =>
    (state.quartileSplitResults = data),
  [AC.UPDATE_QUARTILE_SPLIT_RESULTS_MISSING_TAILS]: (state, data) =>
    (state.quartileSplitResultsMissingTails = data),
  [AC.UPDATE_SELECTOR]: (state, selector) => (state.selection = selector),
  [AC.UPDATE_SORT_ITEM]: (state, data) => (state.sortItem = data),
}

const actions = {
  async [AC.GET_ANALYTIC_RESULT_TYPES]({ commit }, componentId) {
    try {
      const response = await services.analytic.getData(
        'analyticResultTypes',
        { id: componentId },
        false,
      )
      const data = response.data
      commit(AC.UPDATE_ANALYTIC_RESULT_TYPES, data)
    } catch (error) {
      console.log(AC.GET_ANALYTIC_RESULT_TYPES + ': error ' + error)
    }
  },
  async [AC.GET_QUARTILE_RESULTS]({ commit, state }, selector) {
    try {
      commit(AC.UPDATE_SELECTOR, selector)
      commit(AC.UPDATE_QUARTILE_SPLIT_RESULTS_MISSING_TAILS, [])
      const curPhase = state.selection.flightPhase

      const startDate = state.selection.startDate
      const endDate = state.selection.endDate

      const response = await services.analytic.getData(
        'boxAndWhiskerData',
        {
          parameterId: state.selection.parameter,
          flightPhaseId: curPhase,
          airlineIds: selector.airlineIds || [],
          startDate,
          endDate,
        },
        true,
      )

      const retData = response.data || {}
      const updatedFleet = {
        ...retData.fleet,
        tail: 'Fleet',
      }
      const massagedData = {
        ...retData,
        fleets: [updatedFleet],
        tails: (retData.tails || [])
          .filter(tail => state.selection.tails.includes(tail.tail))
          .map(tail => ({
            ...tail,
            unit: response.data.unit,
          })),
      }
      const allResponseTails = (retData.tails || []).map(tail => tail.tail)
      let missingTails = []
      if ((state.selection.tails || []).length > 0) {
        missingTails = (state.selection.tails || []).filter(
          tail => !allResponseTails.includes(tail),
        )
      }
      commit(AC.UPDATE_QUARTILE_SPLIT_RESULTS, massagedData)
      commit(AC.UPDATE_QUARTILE_SPLIT_RESULTS_MISSING_TAILS, missingTails)
      commit(AC.UPDATE_QUARTILE_RAW_RESULTS, retData)
      const fleetData = retData.fleet || {}
      fleetData.unit = retData.unit || ''
      const tailData = (retData.tails || [])
        .filter(tail => state.selection.tails.includes(tail.tail))
        .map(tail => ({
          ...tail,
          unit: response.data.unit,
        }))
      let fullResults = []
      if (Object.prototype.hasOwnProperty.call(fleetData, 'min')) {
        fullResults = [fleetData, ...tailData]
      }
      commit(AC.UPDATE_QUARTILE_RESULTS, fullResults)
    } catch (error) {
      console.log(`${AC.GET_QUARTILE_RESULTS}: error ${error}`)
      commit(AC.UPDATE_QUARTILE_RESULTS, [])
      commit(AC.UPDATE_QUARTILE_SPLIT_RESULTS, { fleets: [], tails: [] })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
